export enum CoachRole {
  HC = "HC",
  AC = "AC",
  AHC = "AHC",
  GC = "GC",
  PC = "PC",
  MS = "MS",
  FC = "FC",
  PAC = "PAC",
}
